import { SecureStorage as Storage } from '@pletly/common';
import { DEFAULT_SETTINGS } from '%screens/settings/components/settingsStore/useSettings';
import { getSettings } from './settings';

const LAST_ACTIVE_STORAGE_KEY = 'lastActiveAt';
const LOCK_AFTER_IN_MINUTES = 5;
const INACTIVE_LIMIT_IN_SECONDS = LOCK_AFTER_IN_MINUTES * 60;

const Lock = {
	set: (value: string) => Storage.set(LAST_ACTIVE_STORAGE_KEY, value),
	get: () => Storage.get(LAST_ACTIVE_STORAGE_KEY),
} as const;

async function saveLastActive() {
	if (!(await getIfShouldLockFromSettings())) {
		return;
	}

	return Lock.set(Date.now().toString());
}

function clearLastActive() {
	return Lock.set('');
}

async function getIfShouldLock() {
	const lastActiveAtString = await Lock.get();
	const lastActiveMillisecondsAgo = Date.now() - Number(lastActiveAtString);

	await clearLastActive();

	if (!(await getIfShouldLockFromSettings())) {
		return false;
	}

	if (lastActiveMillisecondsAgo > INACTIVE_LIMIT_IN_SECONDS * 1000) {
		return true;
	}

	return false;
}

async function getIfShouldLockFromSettings() {
	const defaultSetting = DEFAULT_SETTINGS.security.biometricLock;
	const settings = await getSettings();

	return settings?.security.biometricLock ?? defaultSetting;
}

export {
	saveLastActive,
	clearLastActive,
	getIfShouldLock,
	getIfShouldLockFromSettings,
	LOCK_AFTER_IN_MINUTES,
};
